import ThemeProvider from "@/components/feature/ThemeProvider";
import Navbar from "@/pages/home/components/Navbar";
import HeroSection from "@/pages/home/components/HeroSection";
import IndustriesSection from "@/pages/home/components/IndustriesSection";
import HowItWorksSection from "@/pages/home/components/HowItWorksSection";
import CaseStudiesSection from "@/pages/home/components/CaseStudiesSection";
import ContactSection from "@/pages/home/components/ContactSection";
import BookAuditSection from "@/pages/home/components/BookAuditSection";
import Footer from "@/pages/home/components/Footer";

function HomeContent() {
  return (
    <div className="min-h-screen transition-colors duration-500">
      <Navbar />
      <HeroSection />
      <IndustriesSection />
      <HowItWorksSection />
      <CaseStudiesSection />
      <ContactSection />
      <BookAuditSection />
      <Footer />
    </div>
  );
}

export default function HomePage() {
  return (
    <ThemeProvider>
      <HomeContent />
    </ThemeProvider>
  );
}
